import angular from 'angular';
import _ from 'lodash';

export function TFTTagsService($localStorage) {
    const criteriaTagStyles = _.get($localStorage, 'sysDefaults.colorSchemeSettings.criteriaTagsStyles', {});

    const styleKeys = {
        MUST_HAVE: 'mustHave',
        IMPORTANT: 'important',
        PREFERRED: 'preferred',
        ADVANTAGE: 'advantage',
        PROBLEMATIC: 'problematic',
        DERIVED: 'derived',
        EXCLUDED: 'excluded',
    };

    const classes = {
        ADVANTAGE: 'optional',
        PREFERRED: 'preferred',
        IMPORTANT: 'mandatory',
        REQUIRED: 'filter',
        PROBLEMATIC: 'problematic',
        EXCLUDED: 'excluded',
        DERIVED: 'derived',
        HAS_ICON: 'has-icon',
    };

    const mapStyleKeysToPriority = {
        optional: styleKeys.ADVANTAGE,
        preferred: styleKeys.PREFERRED,
        mandatory: styleKeys.IMPORTANT,
        filter: styleKeys.MUST_HAVE,
    };

    const generateStyles = function (config) {
        if (!config) {
            return {};
        }

        const { fontColor: color, backgroundColor, borderColor } = config;

        return {
            ...(color && { color }),
            ...(backgroundColor && { 'background-color': backgroundColor }),
            ...(borderColor && { 'border-color': borderColor }),
        };
    };

    const generateClassName = (className, hasIcon) => (
        hasIcon ? `${className} ${classes.HAS_ICON}` : className
    );

    const getTagStyles = function ({ priority, isExcluded, isDerived }) {
        let config = criteriaTagStyles[mapStyleKeysToPriority[priority]] || {};
        let className = priority;

        if (isExcluded) {
            config = criteriaTagStyles[styleKeys.EXCLUDED] || {};
            className = classes.EXCLUDED;
        } else if (isDerived) {
            const derivedConfig = criteriaTagStyles[styleKeys.DERIVED];
            config.showIcon = derivedConfig ? derivedConfig.showIcon : true;
            className += ` ${classes.DERIVED}`;
        }

        return {
            className: generateClassName(className, config ? config.showIcon : true),
            styles: generateStyles(config),
        };
    };

    return {
        getTagStyles,
    };
}

angular.module('TALENYA-FE').factory('TFTTagsService', TFTTagsService);
